import { ChangeDetectionStrategy, Component } from '@angular/core'
import { map } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'flo-embed',
  templateUrl: './video-embed.component.html',
  styleUrls: ['./video-embed.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoEmbedComponent {
  constructor(private ar: ActivatedRoute) {}

  embedHash$ = this.ar.params.pipe(map(params => params.embedHash))
}
